import React from "react";
import { SectionModel } from "../../../../../models/guarantorCheque.model";
import DivisionCmp from "../../../../../components/cards/DivisionCmp";
import DetailInfoComponentThumbnail from "../../../../../components/thumbnail/detailInfoComponentThumbnail";


let sections: SectionModel[];
sections = [
    { dataKey: "jobTitle", rowCol: 4, title: "عنوان شغل" },
    {
        dataKey: "monthlyIncome",
        rowCol: 4,
        title: "مجموع مبلغ درآمد",
        dataPostValue: "ریال",
        hasThousandSeparatorFormat: true,
    },
];

export default function GuarantorIncomeInfo(props: any) {
    return (
        <>
            {props.data?.map((item: any) => (
                <DivisionCmp
                    child={
                        <DetailInfoComponentThumbnail
                            sections={sections}
                            data={props}
                            documentList={props.data}
                            title={false}
                            height={"20vh"}
                            showFooter={false}
                            isGuarantor={true}
                        />
                    } title={" اطلاعات شغلی"} className={'mTop5'}>
                </DivisionCmp>
            ))}
        </>
    );
}
